<template>
  <div>
    <div class="row">
      <div class="col">
        <card>
          <div slot="header"><h4 class="card-title">Instance Access</h4></div>
          <div class="row">
            <div class="col-sm-12">
              {{ instance }}
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui';

export default {
  name: 'Welcome',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      trueDisplayValue: 'Yes',
      falseDisplayValue: 'No',
      surveyUrlId: null,
      instance: null
    };
  }
};
</script>
<style></style>
